<mat-icon
  class="currency-prefix"
  [class]="iconClass()"
  [svgIcon]="icon()"
></mat-icon>
